module.exports = __webpack_public_path__ + "static/media/hourglassImage.10d30d73.jpg";